import { Component, OnInit,ElementRef } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import * as html2pdf from 'html2pdf.js';
import *  as  s3_logo_path from './s3-logo-path.json';
@Component({
  selector: 'app-e-cards',
  templateUrl: './e-cards.component.html',
  styleUrls: ['./e-cards.component.css']
})
export class ECardsComponent implements OnInit {
  data: any = {};
  error: any;
  insuranceDetails: Array<any> = [];
  updatedTime: any;
  backgroundAttached: Array<any> = [];
  loading: boolean = false;
  _id: any;
  sliceCardLength: any;
  cardVisibility: boolean;
  insurerLogoDetails: Array<any> = [];
  InsurerLogoCodes: any = [];
  intimate: any = {};
  policyPart: boolean = true;
  editPolicyPart: boolean = false;
  renewPolicyPart: boolean = false;
  claimPart: boolean = false;
  policy: any;
  cardNumber: string;
  contractLimit:string;
  insured: string;
  gender: string;
  relation: string;
  sumInsured: string;
  company: string;
  email: string;
  mobile: string;
  employeeId: string;
  policyNumber: string;
  insurer: string;
  maternity: string;
  roomRent: string;
  policyName: string;
  TPA_NAME: string;
  Age: string;
  policyHolder: string;
  ailment: string;
  diseaseList : any =  ["Accelerated Hypertention","ACL tear","Acute Gastro entritis","Anal Fissure",
  "Appendix","Bronchitis","CA Breast","Carcinoma of any part","Cataract","Cerebrovascular attack","CHOLELITHIASIS","Chronic Kidney Disease","Coronary Artery Disease","CSOM",
  "Dengue","Deviated Nasal Septum","Diabetes Malitus","Enteric Fever","Fever","Fibroid Uterus","Fracture","Hemorrhoids","Inguinal Hernia","Ischemic heart disease","Lower Respiratory tracT Infection",
  "Malaria","Mayocardial Infarction","Osteoarthritis","Other","PIVD","Pneumonitis","Maternity/Pregnancy/Delivery","Renal Stone",
  "Road traffic accident","Seizure disorder","Tonsilittis","TRANSIENT ISCHAMIC ATTACK","Tuberclosis","Umblical Hernia","Upper Respiratory tracT infection","Urinary Tract Infection","Viral Fever"]
  hospitalName: any;
  hospitalCity: any;
  hospitalState: any;
  estimatedAmount: any;
  employeeName: any;
  errorMessage: string;
  intimateSuccessfull: boolean = false;
  intimateFailure: boolean = false;
  registrationNumber: string;
  regDate: any;
  dischargeDate: any;
  viewDetails:Boolean=false;
  selectedCard:Number;
  hasCard:Boolean;
  private onDestroy$: Subject<void> = new Subject<void>();
  downloadEcardDetails: any = {};
  s3LogoList: any = (s3_logo_path as any).default;
  noDataFound:Boolean=false
  showSecurenowFacilities:boolean=true;

  constructor(private serviceURLService: serviceURLService, private router: Router, private titlecasePipe: TitleCasePipe, private elementRef: ElementRef) { }

  ngOnInit() {
    this.insurance();
    this.getCardByCardNumber();
    if((!!localStorage.getItem('pamClientId') && localStorage.getItem('pamClientId').toLowerCase() === "738113".toLowerCase())
      || (!! localStorage.getItem('companyName') && localStorage.getItem('companyName').toLowerCase().trim() === "National Foundation for India-CSOs".toLowerCase().trim())){
      this.showSecurenowFacilities=false
    }
  }

  transformName(headerData) {
    headerData = headerData.split(/(?=[A-Z])/).join(' ');
    return this.titlecasePipe.transform(headerData);
  }

  getCardNumber(cardId,i) {
    localStorage.setItem('cardId' , cardId);
    this.selectedCard=i
  }

  async generateAndDownloadPDF(cardId,i) {
    const downloadEcardDetails=this.insuranceDetails[i]
    const imageSrc=this.insuranceDetails[i].Insurer
    let imagePath;
    let snLogo = '../../assets/images/securenow_logo.svg';
    for(i=0;i<this.s3LogoList.length;i++){
      if(this.s3LogoList[i].insurerName===imageSrc){
        imagePath=this.s3LogoList[i].logo_path;
        break;
      }
    }
    const content = ` 
       <!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous" />
    <title>Document</title>
    <style>
        .pdf-content-to-download {
            width: 550px;
            height: 450px;
            padding: 25px;
            border-radius: 20px;
            border: solid 1px #d9d9d9;
            background: white;
        }

        .headingOfPdf {
            font-family: Roboto;
            font-size: 23px;
            font-weight: bold;
            color: #005aa9;
        }

        .insurer-logo {
            height: 54px;
            object-fit: contain;
        }

        .securenow-logo {
            height: 22px;
            width: auto;
            object-fit: contain;
        }

        .field-label {
            font-size: 16px;
            color: #5a5a5a;
            font-weight: 500;
        }

        .field-value {
            font-size: 14px;
            color: #000000;
            word-break: break-word;
            font-weight: bold;
        }

        /* Added content shift */
        .content-section {
            padding-left: 30px;
            padding-right: 15px;
        }
    </style>
</head>
<body>
    <div class="pdf-content-to-download">
        <div class="d-flex flex-column h-100">
            <!-- Header Section -->
            <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                    <img class="insurer-logo" src="${imagePath}" alt="insurer logo">
                </div>
                <div class="col-auto">
                    <img class="securenow-logo" src="${snLogo}" alt="securenow logo">
                </div>
            </div>

            <!-- Policy Title -->
            <div class="row mt-3">
                <h1 class="headingOfPdf text-center w-100">${downloadEcardDetails.policyName}</h1>
            </div>

            <!-- Details Section -->
            <div class="mt-3 flex-grow-1 content-section">
                <div class="row mb-3">
                    <div class="col-6 pr-2">
                        <div class="field-label">Name</div>
                        <div class="field-value">${downloadEcardDetails.Insured ? downloadEcardDetails.Insured : 'NA'}</div>
                    </div>
                    <div class="col-6 pl-2">
                        <div class="field-label">Policy No.</div>
                        <div class="field-value">
                            ${downloadEcardDetails.policyNo ? downloadEcardDetails.policyNo :
        downloadEcardDetails.policyNumber ? downloadEcardDetails.policyNumber : "NA"}
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-6 pr-2">
                        <div class="field-label">Card No.</div>
                        <div class="field-value">
                            ${downloadEcardDetails.cardNumber ? downloadEcardDetails.cardNumber :
        downloadEcardDetails.cardNo ? downloadEcardDetails.cardNo : "NA"}
                        </div>
                    </div>
                    <div class="col-6 pl-2">
                        <div class="field-label">Sum Insured</div>
                        <div class="field-value">${downloadEcardDetails.sumInsured ? downloadEcardDetails.sumInsured : 'NA'}</div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-6 pr-2">
                        <div class="field-label">Employee Id</div>
                        <div class="field-value">${downloadEcardDetails.empId ? downloadEcardDetails.empId : 'NA'}</div>
                    </div>
                    <div class="col-6 pl-2">
                        <div class="field-label">Policy End Date</div>
                        <div class="field-value">${(downloadEcardDetails.endDate) ? (downloadEcardDetails.endDate) : 'NA'}</div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6 pr-2">
                        <div class="field-label">Age</div>
                        <div class="field-value">${downloadEcardDetails.Age ? downloadEcardDetails.Age : 'NA'}</div>
                    </div>
                    <div class="col-6 pl-2">
                        <div class="field-label">TPA Name</div>
                        <div class="field-value">${downloadEcardDetails.TPA_NAME ? downloadEcardDetails.TPA_NAME : 'NA'}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>
</html>
    `

    const fileName = downloadEcardDetails.policyNo + '.pdf';
    const opt = {
      margin: 10,
      filename: fileName,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }, // Set orientation to portrait
      urlCors: true
    };

    // Generate the PDF after fetching the image
    html2pdf().from(content).set(opt).save(); 
}
  
  insurance() {
    this.loading = true;
    this.data = {
      // "updatedTime": null,
      "contactNumber": localStorage.getItem("mobileNumber")
    }
    var userId = localStorage.getItem("userID")
    this.backgroundAttached = []
    this.serviceURLService.getPoliciesEcards(userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.insuranceDetails = successData.response.notifyPolicy;
      console.log("policies new ", successData.response.notifyPolicy)
      if(this.insuranceDetails.length>0){
        this.hasCard=true
      }
      else{
        this.hasCard=false
      }
      for (let i = 0; i < (successData.response.notifyPolicy).length; i++) {

        var policyData = successData.response.notifyPolicy[i];
        this.InsurerLogoCodes.push(policyData.insurerCode);
        // if((successData.response.policies[i].attachments).length > 0){          
        //   this.backgroundAttached.push({
        //     backgroundURL: successData.response.policies[i].attachments[0].nativePath
        //   })
        // }
      }
      this.getInsurerLogo();
      console.log(this.cardVisibility);
      // this.sliceCardLength = successData.response.notifyPolicy.length;
      if (this.insuranceDetails.length > 0) {
        this.cardVisibility = true;
      } else {
        this.cardVisibility = false;
        this.noDataFound=true
      }
      this.loading = false;
    }, errorData => {
      this.loading = false;
      if (errorData.error.status === 401) {
        this.router.navigate(['login']);
      } else if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
      console.log("not registered");
    })
  }

  getInsurerLogo() {
    // this.loading = true;
    this.serviceURLService.getInsurerLogo().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.insurerLogoDetails = successData.data.insurerDtos;
      for(let i = 0; i < (this.InsurerLogoCodes).length; i++) {
        for(let j = 0; j < (this.insurerLogoDetails).length; j++) {
          if(this.InsurerLogoCodes[i].toLowerCase() === this.insurerLogoDetails[j]?.code?.toLowerCase()) {
            this.insuranceDetails[i].logo = this.insurerLogoDetails[j].insurerLogo;
            console.log("logo ", this.insuranceDetails[i].logo);
            break;
          }
        }
      }
      // this.loading = false;
    }, errorData => {
      this.error = errorData;
      console.log("no data");
    })
  }
  getCardByCardNumber() {
    this.cardNumber = window.location.href.split('/')[4];
    var cardId = localStorage.getItem("cardId");
    this.loading = true;
    this.serviceURLService.getCardDetails(cardId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.policy = successData.response.notifyPolicy;
      this.loading = false;
      for (var i = 0; i < this.policy.length; i++) {
        console.log(this.policy.length);
        this.cardNumber = this.policy[i].cardNumber ? this.policy[i].cardNumber : this.policy[i].cardNo ;
        this.insured = this.policy[i].Insured;
        this.gender = this.policy[i].Gender;
        this.relation = this.policy[i].Relation;
        this.sumInsured = this.policy[i].sumInsured?this.policy[i].sumInsured:this.policy[i]["Sum Insured"];
        this.company = this.policy[i].companyName;
        this.email = this.policy[i].email;
        this.mobile = this.policy[i].phoneNumber;
        this.employeeId = this.policy[i].empId;
        this.policyNumber = this.policy[i].policyNumber ? this.policy[i].policyNumber : this.policy[i].policyNo;
        this.insurer = this.policy[i].Insurer;
        this.maternity = this.policy[i].Maternity;
        this.roomRent = this.policy[i].roomRent?this.policy[i].roomRent:this.policy[i]['Room Rent'];
        this.policyName = this.policy[i].policyName;
        this.TPA_NAME = this.policy[i].TPA_NAME; 
        this.Age = this.policy[i].Age;
        this.policyHolder = this.policy[i].policyHolder; 
        this.contractLimit = this.policy[i]["Contract Limit"];
      }
      this.getInsurerLogo();
      // this.loading = false;
    }, errorData => {
      this.error = errorData;
      console.log("no data");
    })
  }
  submitIntimateDetails(){
    if(this.regDate){
      var newAdmissionDateTime = new Date(this.regDate);
      newAdmissionDateTime.setHours(this.regDate.getHours() + 5);
      newAdmissionDateTime.setMinutes(this.regDate.getMinutes() + 30);
    }
    if(this.dischargeDate) {
      var newDischargeDateTime = new Date(this.dischargeDate);
      newDischargeDateTime.setHours(this.dischargeDate.getHours() + 5);
      newDischargeDateTime.setMinutes(this.dischargeDate.getMinutes() + 30);
    }
    if(this.company == ""){
      this.company = "-"
    }
    this.employeeName = localStorage.getItem('name');
    this.loading = true;
    this.intimate = {
      "mobileNo": this.mobile,
      "corporateName": this.company, 
      "employeeName":this.employeeName,
      "employeeId":this.employeeId,
      "insurer":this.insurer,
      "policyNumber": this.policyNumber,
      "claimant": this.insured,
      "relationWithEmployee":this.relation,
      "cardNumber": this.cardNumber,
      "email" : this.email,
      "productType":"Group Health Insurance",
      "hospitalState":this.hospitalState,
      "hospitalCity":this.hospitalCity,
      "hospitalName":this.hospitalName,
      "estimatedAmount": this.estimatedAmount,
      "claimMode": "REIMBURSEMENT",
      "claimSource":"notify",
      "rm":"",
      "ailment": this.ailment,
      "admissionDate":(newAdmissionDateTime),
      "dischargeDate": (newDischargeDateTime),
      "status":"INTIMATED",
      "subStatus":"INTIMATED",
      "registerManually": false
    }
    this.serviceURLService.submitClaimIntimate(this.intimate).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      
      this.loading = false;
      
      this.errorMessage = successData.error;
      if(!successData.response.pamResponse.success){
        
        this.intimateFailure = true;
      }else{
        this.intimateSuccessfull = true; 
        this.registrationNumber = successData.response.pamResponse.data;
      }
    }, errorData => {
      console.log("Oops..!! there is some error");
      this.loading = false;
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }else if(errorData.error.status === 400){ // temperory solution for registering same number handling 
        this.error = errorData.error.message + " Number is already registered.";
        this.intimateFailure = true;
      }
    })
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    
}

